import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.uploadConfirmationComposingModal.title',
    defaultMessage: 'ESSAY SHEET UPLOAD',
  },
  singularSubtitle: {
    id: 'simulated.uploadConfirmationComposingModal.singularSubtitle',
    defaultMessage: 'Essay sheet successfully processed.',
  },
  pluralSubtitle: {
    id: 'simulated.uploadConfirmationComposingModal.pluralSubtitle',
    defaultMessage: 'Essay sheets processed successfully.',
  },
  close: {
    id: 'simulated.uploadConfirmationComposingModal.close',
    defaultMessage: 'Close',
  },
  errorIntergrationDataNotFound: {
    id: 'simulated.updateEssaySheetConfirmation.errorIntergrationDataNotFound',
    defaultMessage: 'Integration data not found.',
  },
  errorNoPermission: {
    id: 'simulated.updateEssaySheetConfirmation.errorNoPermission',
    defaultMessage: 'This student does not have permission for that school.',
  },
  errorGeneric: {
    id: 'simulated.updateEssaySheetConfirmation.errorGeneric',
    defaultMessage: 'Error loading essay sheet',
  },
  errorUploadingFile: {
    id: 'simulated.updateEssaySheetConfirmation.errorUploadingFile',
    defaultMessage: 'Error while uploading the file to the server',
  },
  errorIntegratingFile: {
    id: 'simulated.updateEssaySheetConfirmation.errorIntegratingFile',
    defaultMessage: 'Error while integrating file',
  },
  errorUploadingFileToStudent: {
    id: 'simulated.updateEssaySheetConfirmation.errorUploadingFileToStudent',
    defaultMessage: 'Error while uploading the file. Try again uploading the file to the student',
  },
  errorGeneric: {
    id: 'simulated.uploadConfirmationComposingModal.errorGeneric',
    defaultMessage: 'Error uploading essay sheet',
  },
  successError: {
    id: 'simulated.uploadConfirmationComposingModal.successError',
    defaultMessage: 'Essay sheets successfully processed with errors.',
  },
});
